import { render } from "./np-upload.vue?vue&type=template&id=2d6ca71d"
import script from "./np-upload.vue?vue&type=script&lang=js"
export * from "./np-upload.vue?vue&type=script&lang=js"

import "./np-upload.vue?vue&type=style&index=0&id=2d6ca71d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__